import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import VehicleCategoryPriceList from "./by_category/VehicleCategoryPriceList";
import VehiclePriceList from "./by_vehicle/VehiclePriceList";

const RentalPricingList = () => {

    return (

        <div className="p-4">
            <Tabs defaultValue="class">
                <TabsList>
                    <TabsTrigger value="class">Price by category</TabsTrigger>
                    <TabsTrigger value="vehicle">Price by vehicle</TabsTrigger>
                </TabsList>
                <TabsContent value="class">
                    <div className="w-full p-6">
                        <VehicleCategoryPriceList />
                    </div>
                </TabsContent>
                <TabsContent value="vehicle">
                    <VehiclePriceList />
                </TabsContent>
            </Tabs>
        </div>
    )
};

export default RentalPricingList;